import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
  returnValue:string|Date="";
  transform(value: any, toTimeZone:string,format:string="MM/dd/yyyy"): any 
  {
  
    this.returnValue=value;
    if(value)
    {
      switch(toTimeZone.toLowerCase()) 
      { 
        case "local": 
        { 
          let date=new Date (new Date(value)+" UTC");
          this.returnValue= super.transform(date,format);
          break; 
        } 
        case "utc": 
        { 
          let d=new Date(value).toUTCString();
          this.returnValue=new Date(d);
          break; 
        } 
        default:
        {
          this.returnValue=super.transform(value,format)
        }
      }
    }
    return this.returnValue
  }
}
